export default "__VITE_ASSET__CA6KR0eb__"